import { CLICKED_HEALTH_ID, HEALTH_REC_TYPES, HEALTH_REC_TYPES_FAILED, HEALTH_REC_TYPES_SUCCESS, HEALTH_REC_UPLOAD, HEALTH_REC_UPLOAD_FAILED, HEALTH_REC_UPLOAD_SUCCESS, HEALTH_RECORD_REQUEST, HEALTH_RECORD_REQUEST_ERROR, HEALTH_RECORD_REQUEST_SUCCESS, RECORD_IMAGE_OPEN, RECORD_IMAGE_OPEN_FAILED, RECORD_IMAGE_OPEN_SUCCESS } from './Constants';

export const healthRecordRequest = (page) => ({
    type: HEALTH_RECORD_REQUEST,
    page : page
});

export const healthRecordRequestSuccess = (payload, page) => ({
    type: HEALTH_RECORD_REQUEST_SUCCESS,
    payload : payload,
    page: page
});

export const healthRecordRequestError = () => ({
    type: HEALTH_RECORD_REQUEST_ERROR,
});

export const clickedHealthRecordIdRequest = (healthId) => ({
    type: CLICKED_HEALTH_ID,
    healthId : healthId
});

export const healthRecordImageRequest = (url) => ({
    type: RECORD_IMAGE_OPEN,
    url : url
});

export const healthRecordImageRequestSuccess = (payload) => ({
    type: RECORD_IMAGE_OPEN_SUCCESS,
    payload : payload
});

export const healthRecordImageRequestError = () => ({
    type: RECORD_IMAGE_OPEN_FAILED,
});

export const healthRecordTypesRequest = () => ({
    type: HEALTH_REC_TYPES,
});

export const healthRecordTypesRequestSuccess = (payload) => ({
    type: HEALTH_REC_TYPES_SUCCESS,
    payload : payload
});

export const healthRecordTypesRequestError = () => ({
    type: HEALTH_REC_TYPES_FAILED,
});

export const healthRecordUploadRequest = (payload) => ({
    type: HEALTH_REC_UPLOAD,
    values: payload
});

export const healthRecordTypesUploadSuccess = (payload) => ({
    type: HEALTH_REC_UPLOAD_SUCCESS,
    payload : payload
});

export const healthRecordTypesUploadError = () => ({
    type: HEALTH_REC_UPLOAD_FAILED,
});